// src/pages/PoliticaTienda.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaArrowLeft,
  FaFileContract,
  FaShieldAlt,
  FaCookieBite,
  FaStore,
  FaShippingFast,
  FaMoneyBillWave,
  FaExchangeAlt
} from 'react-icons/fa';
import '../styles/LegalPages.css';

const PoliticaTienda = () => {
  return (
    <div className="legal-page">
      <div className="legal-energy-field">
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
      </div>

      <div className="legal-container">
        <header className="legal-header">
          <h1>🛒 Políticas de Tienda</h1>
          <p className="legal-subtitle">
            Condiciones de compra, envíos y políticas comerciales de Reanimeitor
          </p>
        </header>

        <div className="legal-content">
          <div className="legal-section">
            <h2><FaStore /> Proceso de compra</h2>
            <p>
              Los pedidos se realizan directamente a través de la tienda online de
              Reanimeitor. El usuario puede seleccionar el producto, completar sus
              datos de envío, realizar el pago y finalizar la compra desde nuestro
              propio sitio web.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaMoneyBillWave /> Precios</h2>
            <p>
              Todos los precios incluyen los impuestos aplicables. Reanimeitor se
              reserva el derecho a modificar los precios sin previo aviso, aunque
              se respetará el precio indicado en el momento de la confirmación del
              pedido.
            </p>
          </div>

          <div className="legal-section">
            <h2>💳 Formas de pago</h2>
            <p>
              El pago se realiza directamente a Reanimeitor mediante los métodos
              disponibles en la plataforma. El pedido no se tramitará hasta que el
              pago haya sido confirmado correctamente.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaShippingFast /> Envíos</h2>
            <p>
              Los envíos se gestionan desde la propia tienda online de Reanimeitor
              mediante integración con GLS. Una vez confirmado el pago, el pedido
              será preparado y tramitado para su envío a través de GLS, que se
              encargará del transporte, entrega y seguimiento del paquete.
            </p>
          </div>

          <div className="legal-section">
            <h2><FaExchangeAlt /> Devoluciones y reclamaciones</h2>
            <p>
              Las devoluciones, incidencias o reclamaciones relacionadas con el
              pedido deberán comunicarse directamente a Reanimeitor. En caso de
              incidencias de transporte, gestionaremos la reclamación correspondiente
              con GLS cuando sea necesario.
            </p>
            <p>
              Reanimeitor revisará cada caso para ofrecer una solución adecuada,
              siempre conforme a la normativa aplicable y a las condiciones de venta
              de la tienda.
            </p>
          </div>

          <div className="legal-section">
            <h2>❌ Cancelaciones</h2>
            <p>
              Los pedidos pueden cancelarse antes de ser preparados o entregados a
              GLS para su envío. Una vez iniciado el proceso logístico, la cancelación
              podrá no ser posible y deberá tramitarse, en su caso, como devolución
              o incidencia.
            </p>
          </div>

          <div className="legal-section">
            <h2>📞 Contacto</h2>
            <p>
              Para cualquier duda previa o posterior a la compra, puedes escribirnos a
              <strong> info@reanimietor.com</strong> o por WhatsApp al
              <strong> 611 701 132</strong>.
            </p>
          </div>

          <Link to="/" className="legal-back-button">
            <FaArrowLeft /> Volver al Inicio
          </Link>

          <div className="legal-navigation">
            <Link to="/aviso-legal" className="legal-nav-button">
              <FaFileContract /> Aviso Legal
            </Link>
            <Link to="/politica-cookies" className="legal-nav-button">
              <FaCookieBite /> Cookies
            </Link>
            <Link to="/politica-privacidad" className="legal-nav-button">
              <FaShieldAlt /> Privacidad
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaTienda;